import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { T, BG, CARD, BORDER, P, LUMINA_SKUS } from './discoverConstants';

export function FieldInput({ field, value, onChange }) {
  if (field.type === 'tags') {
    const selected = Array.isArray(value) ? value : [];
    return (
      <div>
        <p className="text-[8px] text-gray-500 uppercase font-semibold mb-1">{field.label}</p>
        <div className="flex flex-wrap gap-1">
          {field.options.map(opt => {
            const active = selected.includes(opt);
            return (
              <button key={opt} onClick={() => onChange(active ? selected.filter(s => s !== opt) : [...selected, opt])}
                className="px-2 py-1 rounded text-[8px] font-semibold transition-all"
                style={{ background: active ? `${T}18` : BG, color: active ? T : '#555', border: `1px solid ${active ? `${T}40` : BORDER}` }}>{opt}</button>
            );
          })}
        </div>
      </div>
    );
  }
  if (field.type === 'slider') {
    const val = value ?? field.min;
    return (
      <div>
        <div className="flex items-center justify-between mb-1">
          <p className="text-[8px] text-gray-500 uppercase font-semibold">{field.label}</p>
          <span className="text-[9px] font-bold" style={{ color: T }}>{val}{field.unit}</span>
        </div>
        <input type="range" min={field.min} max={field.max} step={field.step} value={val}
          onChange={e => onChange(Number(e.target.value))}
          className="w-full h-1 rounded-full appearance-none cursor-pointer" style={{ accentColor: T, background: BORDER }} />
      </div>
    );
  }
  if (field.type === 'range') {
    return (
      <div>
        <p className="text-[8px] text-gray-500 uppercase font-semibold mb-1">{field.label}</p>
        <div className="flex gap-1.5">
          <input type="number" placeholder="Min" value={value?.min || ''} onChange={e => onChange({ ...(value || {}), min: e.target.value })}
            className="flex-1 px-2 py-1.5 rounded text-[9px] text-white placeholder-gray-600 focus:outline-none" style={{ background: BG, border: `1px solid ${BORDER}` }} />
          <input type="number" placeholder="Max" value={value?.max || ''} onChange={e => onChange({ ...(value || {}), max: e.target.value })}
            className="flex-1 px-2 py-1.5 rounded text-[9px] text-white placeholder-gray-600 focus:outline-none" style={{ background: BG, border: `1px solid ${BORDER}` }} />
        </div>
      </div>
    );
  }
  if (field.type === 'text') {
    return (
      <div>
        <p className="text-[8px] text-gray-500 uppercase font-semibold mb-1">{field.label}</p>
        <input type="text" placeholder={field.placeholder || ''} value={value || ''} onChange={e => onChange(e.target.value)}
          className="w-full px-2 py-1.5 rounded text-[9px] text-white placeholder-gray-600 focus:outline-none" style={{ background: BG, border: `1px solid ${BORDER}` }} />
      </div>
    );
  }
  if (field.type === 'sku_select') {
    const selected = Array.isArray(value) ? value : [];
    return (
      <div>
        <p className="text-[8px] text-gray-500 uppercase font-semibold mb-1">{field.label}</p>
        <div className="flex flex-wrap gap-1">
          {LUMINA_SKUS.map(sku => {
            const active = selected.includes(sku);
            return (
              <button key={sku} onClick={() => onChange(active ? selected.filter(s => s !== sku) : [...selected, sku])}
                className="px-2 py-1 rounded text-[8px] font-semibold transition-all"
                style={{ background: active ? `${P}18` : BG, color: active ? P : '#555', border: `1px solid ${active ? `${P}40` : BORDER}` }}>{sku.split('–')[0].trim()}</button>
            );
          })}
        </div>
      </div>
    );
  }
  return null;
}

export function FilterSection({ cat, filters, setFilters, expanded, onToggle }) {
  const Icon = cat.icon;
  const activeCount = cat.fields.filter(f => {
    const v = filters[f.key];
    return v !== undefined && v !== '' && !(Array.isArray(v) && v.length === 0);
  }).length;

  return (
    <div className="rounded-lg overflow-hidden" style={{ border: `1px solid ${BORDER}` }}>
      <button onClick={onToggle} className="w-full flex items-center gap-2 px-3 py-2.5 text-left transition-all hover:bg-white/[0.02]" data-testid={`section-${cat.id}`}>
        <Icon className="h-3.5 w-3.5 flex-shrink-0" style={{ color: T }} />
        <span className="text-[10px] font-semibold text-white flex-1">{cat.title}</span>
        {activeCount > 0 && <span className="w-4 h-4 rounded-full text-[8px] font-bold flex items-center justify-center" style={{ background: `${T}20`, color: T }}>{activeCount}</span>}
        {expanded ? <ChevronDown className="h-3 w-3 text-gray-600" /> : <ChevronRight className="h-3 w-3 text-gray-600" />}
      </button>
      {expanded && (
        <div className="px-3 pb-3 space-y-2.5">
          {cat.fields.map(field => (
            <FieldInput key={field.key} field={field} value={filters[field.key]} onChange={v => setFilters(prev => ({ ...prev, [field.key]: v }))} />
          ))}
        </div>
      )}
    </div>
  );
}
